interface ApiRequestInfo {
  method?: string;
  url?: string;
}

// Numeric ids, UUIDs and long hex/opaque ids — replaced so every call to the same
// route groups together in Sentry regardless of which record it hit.
// The opaque-id branch requires a digit so long route names (e.g. `ats-notifications-stream`) survive.
const ID_SEGMENT =
  /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{16,}|(?=[^/]*\d)[A-Za-z0-9_-]{20,})$/i;

/** `/api/v1/jobs/42/candidates?page=2` → `/api/v1/jobs/:id/candidates` */
export const normaliseEndpoint = (url?: string): string | null => {
  if (!url) return null;
  const path = url.replace(/^[a-z]+:\/\/[^/]+/i, '').split(/[?#]/)[0];
  const normalised = path
    .split('/')
    .map(segment => (ID_SEGMENT.test(segment) ? ':id' : segment))
    .join('/');
  return normalised.startsWith('/') ? normalised : `/${normalised}`;
};

export class ApiError extends Error {
  status: number | null;
  data: unknown;
  method: string | null;
  endpoint: string | null;

  constructor(message: string, status: number | null, data: unknown, request?: ApiRequestInfo) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
    this.method = request?.method?.toUpperCase() ?? null;
    this.endpoint = normaliseEndpoint(request?.url);
  }
}
